import api from './base-api';

const tradesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		getTradesByMarket: builder.query({
			query: ({ id }: any) => ({
				url: `trades/market/${id}`,
				method: 'GET',
			}),
			extraOptions: { skipAuth: true },
		}),
		setSeenAutoTrade: builder.mutation({
			query: ({ tradeId }: any) => ({
				url: `trades/${tradeId}/seen-auto-trade`,
				method: 'POST',
			}),
			extraOptions: { skipAuth: true },
		}),

		// PRIVATE
		getUserTradesCount: builder.query({
			query: () => ({
				url: 'trades/user-trades-count',
				method: 'GET',
			}),
		}),
		getUserTradesCountByCategory: builder.query({
			query: ({ eventId }: any) => ({
				url: `trades/user-trades-count-category?eventId=${eventId}`,
				method: 'GET',
			}),
		}),
		getHasSecondChanceTrades: builder.query({
			query: ({ lobbyId }: any) => ({
				url: '/trades/second-chance-trades',
				method: 'GET',
				params: { lobbyId },
			}),
		}),
		// ADMIN
		canMakeAutoTrades: builder.mutation({
			query: (body: any) => ({
				url: 'trades/auto-trades',
				method: 'POST',
				body,
			}),
		}),
		startTradingBot: builder.mutation({
			query: (data: any) => ({
				url: 'bot-trades/start',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Market'],
		}),
		getTradesStat: builder.query({
			query: (data: any) => ({
				url: '/trades/stat',
				method: 'POST',
				body: data,
			}),
		}),
		getTradesList: builder.query({
			query: (data: any) => ({
				url: '/trades/list',
				method: 'POST',
				body: data,
			}),
		}),
	}),
});

export default tradesApi;

export const {
	useCanMakeAutoTradesMutation,
	useSetSeenAutoTradeMutation,
	useStartTradingBotMutation,
	useGetTradesListQuery,
	useGetTradesStatQuery,
	useGetHasSecondChanceTradesQuery,
	useGetUserTradesCountQuery,
	useLazyGetTradesByMarketQuery,
	useGetUserTradesCountByCategoryQuery,
} = tradesApi;
